/* eslint-disable react/no-unused-state */

/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Form from 'Component/Form';
import { VALIDATION_INPUT_TYPE } from 'Util/Validator/Config';

import './FormMondlyPopup.style';

/**
 * A popup capable of displaying a video
 * @class VideoPopup
 * @namespace Bookland/Component/FormMondlyPopup/Component */
export class FormMondlyPopup extends PureComponent {
    static propTypes = {
        submitForm: PropTypes.func.isRequired
    };

    renderFormBody() {
        return (
            <>
                <Field
                  type={ FIELD_TYPE.text }
                  label={ __('Order number (internet store) or invoice number (stationary store)') }
                  attr={ {
                      id: 'number',
                      name: 'number',
                      placeholder: __('Number')
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      isRequired: true
                  } }
                  addRequiredTag
                />
                <Field
                  type={ FIELD_TYPE.text }
                  label={ __('E-mail') }
                  attr={ {
                      id: 'email',
                      name: 'email',
                      placeholder: __('E-mail')
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      inputType: VALIDATION_INPUT_TYPE.email,
                      isRequired: true
                  } }
                  addRequiredTag
                />
                <Field
                  type={ FIELD_TYPE.checkbox }
                  label={ (
                            <span>
                                Akceptuję
                                <a href="/regulamin-mondly">regulamin</a>
                            </span>
                          ) }
                  attr={ {
                      id: 't1',
                      name: 't1'
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      isRequired: true
                  } }
                />
                <Field
                  type={ FIELD_TYPE.checkbox }
                  label={ (
                            <span>
                                Potwierdzam, że zapoznałem się z polityką prywatności sklepu internetowego. Sprawdź
                                <a href="/polityka-prywatnosci">politykę prywatności.</a>
                                { /* eslint-disable-next-line max-len */ }
                                Administratorem danych osobowych zbieranych za pośrednictwem sklepu internetowego jest Edu-Książka sp. z o.o. Dane są lub mogą być przetwarzane w celach oraz na podstawie wskazanych szczegółowo w polityce prywatności (np. realizacja umowy, marketing bezpośredni). Polityka prywatności zawiera pełną informację na temat przetwarzania danych przez administratora wraz z prawami przysługującymi osobie, której dane dotyczą.
                            </span>
                          ) }
                  attr={ {
                      id: 't2',
                      name: 't2'
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      isRequired: true
                  } }
                />
                <Field
                  type={ FIELD_TYPE.checkbox }
                  // eslint-disable-next-line max-len
                  label="Zgadzam się na przetwarzanie moich danych osobowych (adres e-mail) przez Edu-Książka sp. z o.o. w celu marketingowym. Wyrażenie zgody jest dobrowolne. Mam prawo cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem."
                  attr={ {
                      id: 't3',
                      name: 't3'
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      isRequired: false
                  } }
                  addRequiredTag
                />
            </>
        );
    }

    renderSubmitBtn() {
        return (
            <button
              block="Button"
              type="submit"
            >
                { __('Send') }
            </button>
        );
    }

    rednerPopupDesc() {
        return (
            <span block="FormMondlyPopup" elem="Desc">
                Formularz promocyjny
            </span>
        );
    }

    render() {
        const { submitForm } = this.props;

        return (
            <div
              block="FormMondly"
              elem="Wrapper"
            >
                <div id="FormMondly" block="FormMondlyPopup" elem="Wrapper">
                    { this.rednerPopupDesc() }
                    <Form block="FieldForm" onSubmit={ submitForm }>
                        { this.renderFormBody() }
                        { this.renderSubmitBtn() }
                    </Form>
                </div>
            </div>
        );
    }
}

export default FormMondlyPopup;
